import React, { useContext, useEffect, useState } from 'react';
import { IIvsEventSimpleProps } from '../../../services/Events/IvsEventsService/types';
import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { Box } from '@mui/material';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { IVS_EVENT_ENDPOINT } from '../../../services/Events/IvsEventsService';
import { IPaginationParams } from '../../../services/types';
import { AppContext } from '../../../context/AppContextProvider';
import { useGetAllIvsEventByLicenseCountAsync } from '../../../services/Events/IvsEventsService/hooks/useMutation';
import ImageModalComponent from '../../../components/ImageModalComponent';
import ImageSimpleColumnComponent from '../../../components/ImageSimpleColumnComponent';
import { IEventPauseUpdateParams } from '../../../services/Events/types';
import {
  IVS_EVENT_CACHE_KEY,
  useIvsEventDataStreamCache,
} from '../../../services/Events/IvsEventsService/hooks/useQueryClient';
import PauseButtonComponent from '../../../components/PauseButtonComponent';
import { t } from 'i18next';

const IvsEventList = () => {
  const [events, setEvents] = useState<IIvsEventSimpleProps[]>([]);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const { setIsShowLoadingComponent } = useContext(AppContext);
  const [eventCount, setEventCount] = useState<number>(0);
  const { mutateAsync: mutateGetAllIvsEventByLicenseCount } =
    useGetAllIvsEventByLicenseCountAsync();
  const [isVisibleImageModal, setIsVisibleImageModal] =
    useState<boolean>(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const { setCacheData, getCacheData, clearCacheData } =
    useIvsEventDataStreamCache();
  const [pausedUpdateParams, setPausedUpdateParams] =
    useState<IEventPauseUpdateParams>({
      isPaused: false,
      cacheKey: IVS_EVENT_CACHE_KEY,
      setCacheData: setCacheData,
      getCacheData: getCacheData,
      clearCacheData: clearCacheData,
    });

  const columns: IColumnProps[] = [
    {
      id: 'device.name',
      label: t('common.device'),
      width: 200,
    },
    {
      id: 'image',
      label: t('common.image'),
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      id: 'createdAt',
      label: t('common.date'),
      width: '20%',
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };

  const onResponseStream = () => {
    mutateGetAllIvsEventByLicenseCount().then(setEventCount);
  };

  const refetchEvents = async () => {
    await getStreamByEndpointAsync(
      IVS_EVENT_ENDPOINT,
      setEvents,
      pagination,
      onResponseStream,
      setIsShowLoadingComponent,
      pausedUpdateParams,
    );
  };

  useEffect(() => {
    setIsShowLoadingComponent(true);
    refetchEvents();
  }, [pagination, pausedUpdateParams.isPaused]);

  return (
    <Box>
      <TableComponent
        columns={columns}
        rows={events}
        totalCount={eventCount}
        onChangePageOrRowsPerPage={setPagination}
        additionalTitleComponent={
          <PauseButtonComponent
            pausedUpdateParams={pausedUpdateParams}
            setPausedUpdateParams={setPausedUpdateParams}
          />
        }
        sortByName={'createdAt'}
        title={t('monitoring.eventsIVS')}
      />
      <ImageModalComponent
        isOpen={isVisibleImageModal}
        handleClose={() => setIsVisibleImageModal(false)}
        imageUrl={imageUrlToRender}
      />
    </Box>
  );
};

export default IvsEventList;
